import { DevToolsModal } from "./DevToolsModal"
import { Loader } from "./Loader"
import { SettingsModal } from "./SettingsModal"

export const COMMON_MODALS = {
  pageLoading: {
    component: Loader
  },
  settings: {
    component: SettingsModal,
    params: {} as {
      onBack?: () => void
    }
  },
  devTools: {
    component: DevToolsModal
  }
} as const
